var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from "react";

function SvgMessenger(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    fill: "#007FFF",
    d: "M16 8c-4.418 0-8 3.316-8 7.407 0 2.332 1.163 4.41 2.981 5.769V24l2.724-1.495c.727.201 1.497.31 2.295.31 4.418 0 8-3.317 8-7.408C24 11.317 20.418 8 16 8zm.795 9.975l-2.037-2.173-3.975 2.173 4.372-4.642 2.087 2.173 3.926-2.173-4.373 4.642z"
  }));
}

export default SvgMessenger;